import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADDMEDICALTEST, BASE_URL, ALL_TEST } from 'src/app/endpoints';

@Injectable({
  providedIn: 'root'
})
export class MedicalTestService {

  constructor(private http: HttpClient) { }

  // Get all predefined lab tests
  getAllTests(data: any) {
    return this.http.post<any>(BASE_URL + ALL_TEST, data);
  }

  // Add medical test with images
  addMedicalTest(formData: FormData) {
    return this.http.post<any>(BASE_URL + ADDMEDICALTEST, formData);
  }

  // Delete medical test
  deleteMedicalTest(data: any) {
    return this.http.post<any>(BASE_URL + 'MedicalTest/delete', data);
  }

  // Get all medical tests for a sample
  getAllMedicalTests(data: any) {
    return this.http.post<any>(BASE_URL + 'MedicalTest/all', data);
  }

  // Update medical test
  updateMedicalTest(formData: FormData) {
    return this.http.post<any>(BASE_URL + 'MedicalTest/update', formData);
  }

  // Get single medical test
  getSingleMedicalTest(data: any) {
    return this.http.post<any>(BASE_URL + 'MedicalTest/single', data);
  }
}
